import { Helmet } from 'react-helmet';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import DashboardHeader from '../DashboardHome/DashboardHeader/DashboardHeader';
import DashboardENTHistory from './DashboardENTHistory/DashboardENTHistory';
import DashboardENTLastMonths from './DashboardENTLastMonths/DashboardENTLastMonths';
// import DashboardENTWidgetsList from "./DashboardENTWidgetsList/DashboardENTWidgetsList"

export default () => {
  return (
    <>
      <Helmet>
        <title>Tableau de bord</title>
      </Helmet>
      <DashboardLayout>
        <DashboardHeader />
        {/* <DashboardENTWidgetsList /> */}
        <section className="dashboard__main-row" style={{ marginTop: 'var(--spacing-s)' }}>
          <DashboardENTHistory />
          <DashboardENTLastMonths />
        </section>
      </DashboardLayout>
    </>
  );
};
